var exports = {
  "D": "xe533113f--6d3e7d--carousel",
};

module.exports = exports;
